export default __webpack_public_path__ + "static/media/ThrowBackAttack-BestMix1.ab9336b6.mp3";